import getContractorList from './getContractorList';
import handelCancelSearchContractorModal from './handelCancelSearchContractorModal';
const contractorFunctions = {
  getContractorList,
  handelCancelSearchContractorModal,
};
export default contractorFunctions;
